// French translations
export const fr = {
  // App
  appName: 'CarTrip',
  
  // Auth
  signIn: 'Se connecter',
  signUp: 'S\'inscrire',
  signOut: 'Se déconnecter',
  email: 'E-mail',
  emailAddress: 'Adresse e-mail',
  password: 'Mot de passe',
  fullName: 'Nom complet',
  enterEmail: 'Entrez votre e-mail',
  enterPassword: 'Entrez votre mot de passe',
  enterFullName: 'Entrez votre nom complet',
  authentication: 'Authentification',
  planTripsEase: 'Planifiez vos voyages en toute simplicité',
  loginRequired: 'Connexion requise',
  loginRequiredDescription: 'Veuillez vous connecter pour créer et gérer les arrêts de voyage',
  
  // Navigation
  home: 'Accueil',
  profile: 'Profil',
  settings: 'Paramètres',
  menu: 'Menu',
  analytics: 'Analytique',
  
  // Trips
  myTrips: 'Mes Voyages',
  newTrip: 'Nouveau Voyage',
  selectTrip: 'Sélectionner un Voyage',
  tripName: 'Nom du Voyage',
  tripNamePlaceholder: 'ex. Vacances d\'été 2025',
  createTrip: 'Créer un Voyage',
  createFirstTrip: 'Créez votre premier voyage!',
  deleteTrip: 'Supprimer le Voyage',
  noTrips: 'Pas encore de voyages. Créez votre premier voyage!',
  stops: 'arrêts',
  stopsTitle: 'Arrêts',
  stopsCount: "Nombre d'arrêts",
  tripHistory: 'Historique des Voyages',
  searchTrips: 'Rechercher des voyages...',
  
  // Stops
  addStop: 'Ajouter un Arrêt',
  editStop: 'Modifier l\'Arrêt',
  deleteStop: 'Supprimer l\'Arrêt',
  noStops: 'Pas encore d\'arrêts',
  address: 'Adresse',
  stopType: 'Type d\'Arrêt',
  stopName: 'Nom de l\'Arrêt',
  notes: 'Notes',
  
  // Stop types
  city: 'Ville',
  gasStation: 'Station-service',
  evCharging: 'Borne de Recharge',
  restaurant: 'Restaurant',
  hotel: 'Hôtel',
  attraction: 'Attraction',
  parking: 'Parking',
  rest: 'Aire de Repos',
  other: 'Autre',
  
  // Map
  map: 'Carte',
  findNearbyPOI: 'Trouver des POI à proximité',
  customStop: 'Arrêt Personnalisé',
  
  // Timeline
  timeline: 'Chronologie',
  
  // Calculator
  tripCalculator: 'Calculateur de Voyage',
  totalDistance: 'Distance Totale',
  totalDuration: 'Durée Totale',
  totalCost: 'Coût Total',
  fuelCost: 'Coût du Carburant',
  
  // Settings
  language: 'Langue',
  languageNative: 'Langue',
  theme: 'Thème',
  appearance: 'Apparence',
  themeLight: 'Clair',
  themeDark: 'Sombre',
  themeAuto: 'Automatique',
  mapLabels: 'Étiquettes de Carte',
  cityAndStreetNames: 'Noms de villes et de rues',
  localLanguage: 'Langue Locale',
  englishLanguage: 'Anglais',
  
  // Vehicles
  vehicles: 'Véhicules',
  myVehicles: 'Mes Véhicules',
  addVehicle: 'Ajouter un Véhicule',
  noVehicles: 'Pas encore de véhicules',
  
  // Common
  cancel: 'Annuler',
  delete: 'Supprimer',
  close: 'Fermer',
  save: 'Enregistrer',
  edit: 'Modifier',
  add: 'Ajouter',
  search: 'Rechercher',
  loading: 'Chargement...',
  error: 'Erreur',
  success: 'Succès',
}
